import { useMutation, gql } from '@apollo/client';
import {
  DeletarProjetoMutation,
  DeletarProjetoMutationVariables,
} from './__generated__/DeletarProjetoMutation';

const DELETAR_PROJETO_MUTATION = gql`
  mutation DeletarProjetoMutation($id_projeto_pedagogico: Int!) {
    deletarProjetoPedagogico(id_projeto_pedagogico: $id_projeto_pedagogico) {
      id_projeto_pedagogico
    }
  }
`;

const useDeletarProjetoMutation = () => {
  return useMutation<DeletarProjetoMutation, DeletarProjetoMutationVariables>(
    DELETAR_PROJETO_MUTATION
  );
};

export { useDeletarProjetoMutation };
